const preorderTags = ['_preorder', '_upcoming'];

function generateGroupId() {
  return 'QUT-' + Math.floor(100000 + Math.random() * 900000);
}

async function handleCheckoutClick(e) {
  e.preventDefault();

  const cart = await fetch('/cart.js').then(res => res.json());

  const preorderItems = [];
  const onhandItems = [];

  cart.items.forEach(item => {
    const tags = item.product_tags || [];
    if (tags.some(tag => preorderTags.includes(tag))) {
      preorderItems.push(item);
    } else {
      onhandItems.push(item);
    }
  });

  if (preorderItems.length === 0) {
    window.location.href = '/checkout';
    return;
  }

  const groupId = generateGroupId();

  // Save group ID
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      attributes: { group_order_id: groupId }
    })
  });

  // Send preorder items to backend
  const res = await fetch('/apps/preorder-split', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      items: preorderItems,
      groupId
    })
  });

  if (!res.ok) {
    alert('Something went wrong. Please try again.');
    return;
  }

  // Remove preorder items
  for (let item of preorderItems) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        id: item.key,
        quantity: 0
      })
    });
  }

  window.location.href = '/checkout';
}

function attachCheckoutInterceptor() {
  const btn = document.querySelector('[name="checkout"]');
  if (!btn) return;

  btn.addEventListener('click', handleCheckoutClick);
}

document.addEventListener('DOMContentLoaded', attachCheckoutInterceptor);